function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-876-2121h1920v7379H-876z"
}), React.createElement("path", {
  d: "M-876-1779h1920v7037H-876z"
}), React.createElement("path", {
  d: "M-502 36V20H670v16"
}), React.createElement("g", {
  transform: "translate(-29 -1)"
}, React.createElement("rect", {
  width: 226,
  height: 42,
  rx: 21
}), React.createElement("path", {
  d: "M56.88 5.875c.748 0 1.368.562 1.439 1.274l.006.136V9.75h2.529c.748 0 1.368.562 1.438 1.275l.007.135v16.916c0 .72-.409 1.693-.93 2.254l-.123.121-4.036 3.707c-.534.49-1.533.899-2.308.958l-.189.008H42.432c-.748 0-1.368-.562-1.438-1.274l-.007-.136V31.25h-2.529c-.748 0-1.368-.562-1.438-1.275l-.007-.135V7.285c0-.73.576-1.335 1.307-1.404l.138-.006h18.423zm3.974 4.934H42.432a.365.365 0 0 0-.354.282l-.007.07v22.554a.36.36 0 0 0 .289.345l.072.008h12.28c.073 0 .152-.008.235-.02l.127-.023v-3.658c.002-1.02.812-1.857 1.839-1.932l.148-.006h4.104c.02-.084.035-.166.043-.242l.006-.11.001-16.916a.362.362 0 0 0-.361-.352zm-.18 18.677h-3.613a.912.912 0 0 0-.638.26.872.872 0 0 0-.257.503l-.008.118v3.243c.079-.047.153-.096.218-.146l.091-.075 4.036-3.706a1.49 1.49 0 0 0 .172-.197zM56.882 6.932H38.458a.365.365 0 0 0-.353.283l-.008.07v22.554a.36.36 0 0 0 .29.345l.071.007h2.529v-19.03c0-.73.575-1.334 1.306-1.403l.139-.006h14.81V7.285a.362.362 0 0 0-.361-.353zm-4.696 18.326c.3 0 .542.236.542.528 0 .263-.197.48-.454.522l-.088.007h-5.78a.535.535 0 0 1-.541-.529c0-.263.196-.48.454-.522l.088-.006h5.78zm4.696-3.525c.299 0 .542.237.542.529 0 .263-.197.48-.454.522l-.088.007H46.406a.535.535 0 0 1-.542-.529c0-.263.196-.48.454-.522l.088-.007H56.88zm0-3.524c.299 0 .542.237.542.529a.535.535 0 0 1-.542.529H46.406a.535.535 0 0 1-.542-.53c0-.291.242-.528.542-.528zm0-3.524c.299 0 .542.237.542.529 0 .263-.197.48-.454.522l-.088.006H46.406a.535.535 0 0 1-.542-.528c0-.263.196-.481.454-.522l.088-.007H56.88z",
  fill: "currentColor",
  fillRule: "nonzero"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 41,
    height: 39
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/raport.891e57b1.svg";
export { SvgComponent as ReactComponent };